var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaternity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 46,
    fill: "#FBE0E2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#A95E5C",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 42,
    r: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5 50c-7.8 4-12.5 11.7-12.5 21.3V89h34v-8.6c0-11.6-7.2-22-18.3-26.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 52c4.3 2.9 7.1 7.7 7.1 13.2 0 4.5-1.9 8.5-5 11.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5 72c7.7 1.3 13.6 7.5 13.6 15.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 83.7c3.2-4.7 7.8-7.1 13.7-7.1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaternity);
export default __webpack_public_path__ + "static/media/maternity.3cbb8216728fd60095a8a3d98c65327e.svg";
export { ForwardRef as ReactComponent };